import { useCallback } from "react";

import {
  focusModalInitialElement,
  resolveModalInitialFocusElement,
} from "./utils/resolveModalInitialFocusElement";

export const useModalInitialFocus = ({
  floatingElement,
}: {
  floatingElement: HTMLElement | null;
}) => {
  const getInitialFocusElement = useCallback(
    () => resolveModalInitialFocusElement(floatingElement),
    [floatingElement]
  );

  const runInitialFocusWhenOpen = useCallback(() => {
    const timeoutId = window.setTimeout(() => {
      const element = getInitialFocusElement();
      if (element) {
        focusModalInitialElement(element);
      }
    }, 0);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [getInitialFocusElement]);

  return {
    getInitialFocusElement,
    runInitialFocusWhenOpen,
  };
};
